import React from "react";

import {
  PriorityHighIcon,
  PriorityLowIcon,
  PriorityMidIcon,
} from "fe-shared/src/components/Icons";
import { PickupRequestPriority } from "../../types";

interface Props {
  priority: PickupRequestPriority;
}

const PRIORITY_ICON_MAP = {
  [PickupRequestPriority.High]: PriorityHighIcon,
  [PickupRequestPriority.Mid]: PriorityMidIcon,
  [PickupRequestPriority.Low]: PriorityLowIcon,
};

const PriorityIcon = ({ priority }: Props) => {
  const Icon = PRIORITY_ICON_MAP[priority];

  return <Icon />;
};

export default PriorityIcon;
